export enum ModalDataHooks {
  Main = 'form-modal-main',
  Title = 'form-modal-title',
  Subtitle = 'form-modal-subtitle',
  PrimaryButton = 'form-modal-primary-button',
  SecondaryButton = 'form-modal-secondary-button',
  Spinner = 'modal-facade-spinner',
}
